export default {
    actions: 'Actions',
    admin: 'Admin',
    address: 'Address',
    all: 'All',
    availability: 'Availability',
    awaitingApproval: 'Awaiting Approval',
    back: 'Back',
    business: 'Business',
    businesses: 'Businesses',
    cancel: 'Cancel',
    categories: 'Categories',
    category: 'Category',
    comingSoon: {
        title: 'This feature is currently in development.',
        message: 'Please check back later for updates.',
    },
    confirm: 'Confirm',
    contact: 'Contact',
    continue: 'Continue',
    description: 'Description',
    edit: 'Edit',
    email: 'Email',
    english: 'English',
    followers: 'Followers',
    following: 'Following',
    french: 'French',
    hour: 'Hour',
    hours: 'Hours',
    influencer: 'Influencer',
    instagram: 'Instagram',
    login: 'Login',
    logout: 'Logout',
    next: 'Next',
    offer: 'Offer',
    optional: 'Optional',
    phone: 'Phone',
    posts: 'Posts',
    reject: 'Reject',
    remove: 'Remove',
    reward: 'Reward',
    stories: 'Stories',
    reels: 'Reels',
    claimLink: {
        title: 'Open this in the INVI app',
        description: 'This conversation lives in the INVI app. Open it there to reply, or install the app if you do not have it yet.',
        openApp: 'Open in the app',
        appStore: 'Download on the App Store',
        playStore: 'Get it on Google Play',
        desktopTitle: 'Open this on your phone',
        desktopDescription: 'INVI is a mobile app. Open this link on the phone where INVI is installed to continue the conversation.',
    },
    close: 'Close',
    day: 'Day',
    days: 'Days',
    disabled: 'Disabled',
    draft: 'Draft',
    drafts: 'Drafts',
    finishSetup: 'Finish setup',
    live: 'Live',
    manage: 'Manage',
    more: 'More',
    new: 'New',
    newCount_one: '{{count}} new',
    newCount_other: '{{count}} new',
    newRequests: 'New Requests',
    notSubmitted: 'Not submitted',
    notValid: 'not valid',
    of: 'of',
    offers: 'Offers',
    offersCount_one: '{{count}} offer',
    offersCount_other: '{{count}} offers',
    open: 'Open',
    pending: 'Pending',
    photos: 'Photos',
    profile: 'Profile',
    request: 'Request',
    requests: 'Requests',
    show: 'Show',
    showThem: 'Show them',
    submit: 'Submit',
    submitted: 'Submitted',
    unfinished: 'Unfinished',
    viewSubmission: 'View submission',
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekend: 'Weekend',
    weekends: 'Weekends',
};
